import React, { Context, createContext, ReactElement, ReactNode } from 'react'

// Settings context type.
export type ConfigureReportSettingsContextType = {
    isDateTimeOnly?: boolean
}

type Props = {
    settings: ConfigureReportSettingsContextType
    children: ReactNode
}

export const ConfigureReportSettingsContextProvider: React.FC<Props> = ({
    settings,
    children
}: Props): ReactElement => (
    <ConfigureReportSettingsContext.Provider value={settings}>{children}</ConfigureReportSettingsContext.Provider>
)

// Create context.
const ConfigureReportSettingsContext: Context<ConfigureReportSettingsContextType> =
    createContext<ConfigureReportSettingsContextType>({})
export default ConfigureReportSettingsContext
